var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.935 6.00485C11.935 5.63715 11.638 5.34017 11.2703 5.34017L6.66468 5.33546L6.66468 0.72512C6.66468 0.357424 6.3677 0.0604396 6 0.0604396C5.6323 0.0604396 5.33532 0.357424 5.33532 0.72512L5.33532 5.33546L0.724982 5.33546C0.357287 5.33546 0.0603021 5.63244 0.0603019 6.00014C0.0603018 6.36783 0.357287 6.66482 0.724982 6.66482L5.33532 6.66482V11.2752C5.33532 11.6428 5.6323 11.9398 6 11.9398C6.3677 11.9398 6.66468 11.6428 6.66468 11.2752V6.66482L11.275 6.66482C11.6333 6.66482 11.935 6.36312 11.935 6.00485Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b820d5ea1d8ef80d662f3a6aa5dc65ee.svg";
export { ForwardRef as ReactComponent };